import { UseQueryResult, UseSuspenseQueryResult, useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { delayedFunction } from '~/utils/utilityFunctions'

import { api } from '~/lib/api-client'
import { Company, CompanyCode, Contact, Webinar } from '~/types/api'

export const useCompany = (): UseQueryResult<Company, Error> => {
  const fetchCompany = async (): Promise<Company> => {
    const res = await api.get<Company>('/api/v1/company/info')
    return res.data
  }
  return useQuery<Company, Error>({
    queryKey: ['company'],
    queryFn: delayedFunction(fetchCompany, 300),
    staleTime: 1,
  })
}

export const useContacts = (): UseSuspenseQueryResult<Contact[], Error> => {
  const fetchContacts = async (): Promise<Contact[]> => {
    const res = await api.get<Contact[]>('/rh/admin_users')
    return res.data
  }
  return useSuspenseQuery<Contact[], Error>({
    queryKey: ['contacts'],
    queryFn: delayedFunction(fetchContacts, 300),
    staleTime: 1,
  })
}

export const useWebinars = (): UseQueryResult<Webinar[], Error> => {
  const fetchWebinars = async (): Promise<Webinar[]> => {
    const res = await api.get<Webinar[]>('/rh/webinars')
    return res.data
  }
  return useQuery<Webinar[], Error>({
    queryKey: ['webinars'],
    queryFn: delayedFunction(fetchWebinars, 300),
    staleTime: 1,
  })
}

export const useCompanyCode = (): UseSuspenseQueryResult<CompanyCode, Error> => {
  const fetchCompanyCode = async (): Promise<CompanyCode> => {
    const res = await api.get<CompanyCode>('/rh/company_code')
    return res.data
  }
  return useSuspenseQuery<CompanyCode, Error>({
    queryKey: ['company-code'],
    queryFn: delayedFunction(fetchCompanyCode, 300),
    staleTime: 1,
  })
}
